export default __webpack_public_path__ + "static/media/zoho-logo.5770cd77.svg";